const coinNames: any = {
  BTC: "Bitcoin",
  ETH: "Ethereum",
  TUSD: "TrueUSD",
  BNB: "Binance Coin",
  USDT: "Tether",
  XRP: "Ripple",
  XMR: "Monero",
  ETC: "Ethereum Classic",
  BTG: "Bitcoin Gold",
  LTC: "Litecoin",
  XVG: "Verge",
  ADA: "Cardano",
  XLM: "Stellar Lumens",
  BTT: "BitTorrent",
  ENJ: "Enjin Coin",
  ONT: "Ontology",
  ZEC: "ZCash",
  BCD: "Bitcoin Diamond",
  NXS: "Nexus",
  PAX: "Paxos",
  EUR: "Euro",
  QUO: "Quo Coin",
  SOL: "Solana",
  DASH: "Dash",
  DOGE: "Dogecoin",
  FIL: "Filecoin",
  LINK: "Chainlink",
  NEO: "Neo",
  TRX: "Tron",
  VET: "VeChain",
  DOT: "Polkadot",
  AAVE: "Aave",
  KNC: "Kyber Network",
  WAVES: "Waves",
  DCR: "Decred",
  MATIC: "Polygon",
  COMP: "Compound",
  THETA: "Theta",
  UNI: "Uniswap",
  YFI: "yearn.finance",
  FTM: "Fantom",
  XTZ: "Tezos",
  SNX: "Synthetix",
  ARB: "Arbitrum",
  ICP: "Internet Computer",
  NEAR: "Near",
  AVAX: "Avalanche",
  EOS: "EOS",
  EGLD: "Elrond",
  PEPE: "Pepe",
  ALGO: "Algorand",
  "1INCH": "1inch",
  XEM: "NEM",
  SHIB: "Shiba Inu"
};
export const getCoinName = (coinId: string | undefined): string => {
  if (!coinId) {
    return "";
  }
  return coinNames[coinId] || coinId;
};
